import * as ng from 'angular';
import { DropboxService } from '../../../../services/dropbox.service';
import { GoogleDriveService } from '../../../../services/google-drive.service';

class ArchidriveShareController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'store',
        '$window',
        'DropboxService',
        'GoogleDriveService',
        '$interval'
    ];

    private close: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private store: ng.a0.storage.IStoreService,
        private $window: ng.IWindowService,
        private DropboxService: DropboxService,
        private GoogleDriveService: GoogleDriveService,
        private $interval: ng.IIntervalService
    ) {
        $scope.user = store.get('user');
        $scope.items = $scope.$parent.$resolve.items;
        $scope.selectedItems = $scope.$parent.$resolve.selectedItems;
        $scope.verifyingDropboxAuthorization = false;
        $scope.dropboxAuthorizationDone = false;
        $scope.dropboxAuthorizationInProgress = false;
        $scope.dropboxUploadingInProgress = false;
        $scope.dropboxSuccessUpload = false;
        $scope.dropboxErrorOnUpload = false;
        $scope.verifyingGoogleDriveAuthorization = false;
        $scope.googleDriveAuthorizationDone = false;
        $scope.googleDriveAuthorizationInProgress = false;
        $scope.googleDriveUploadingInProgress = false;
        $scope.googleDriveSuccessUpload = false;
        $scope.googleDriveErrorOnUpload = false;

        $scope.cancel = () => {
            this.close();
        };

        let getFilesFromSelectedItems = () => {
            let files = $.map($scope.items, (obj, index) => {
                if ($.inArray(obj.storage_path, $scope.selectedItems) > -1) {
                    return obj;
                }
            });
            return files;
        };

        $scope.uploadDropboxFiles = () => {
            $scope.dropboxUploadingInProgress = true;
            let files = getFilesFromSelectedItems();

            DropboxService.uploadFiles(files)
                .then(() => {
                    $scope.dropboxUploadingInProgress = false;
                    $scope.dropboxSuccessUpload = true;
                    $scope.dropboxErrorOnUpload = false;
                }, (error) => {
                    $scope.dropboxSuccessUpload = false;
                    $scope.dropboxErrorOnUpload = true;

                    if (error.data.errorCode === $rootScope.ArchiSmallERRORS.INVALID_ACCESS_TOKEN) {
                        DropboxService.getAuthorizationUrl()
                            .then((resp) => {
                                $scope.dropboxAuthorizationUrl = resp;
                                $scope.dropboxAuthorizationDone = false;
                                $scope.dropboxUploadingInProgress = false;
                            }, (err) => {
                                $scope.dropboxUploadingInProgress = false;
                                $rootScope.alert('error', err.data);
                            });
                    } else {
                        $scope.dropboxUploadingInProgress = false;
                        $rootScope.alert('error', error.data);
                    }
                });
        };

        $scope.uploadGoogleDriveFiles = () => {
            $scope.googleDriveUploadingInProgress = true;
            let files = getFilesFromSelectedItems();

            GoogleDriveService.uploadFiles(files)
                .then((response) => {
                    $scope.googleDriveUploadingInProgress = false;
                    $scope.googleDriveSuccessUpload = true;
                    $scope.googleDriveErrorOnUpload = false;
                }, (error) => {
                    $scope.googleDriveSuccessUpload = false;
                    $scope.googleDriveErrorOnUpload = true;

                    if (error.data.errorCode === $rootScope.ArchiSmallERRORS.INVALID_ACCESS_TOKEN) {
                        GoogleDriveService.getAuthorizationUrl()
                            .then((resp) => {
                                $scope.googleDriveAuthorizationUrl = resp;
                                $scope.googleDriveAuthorizationDone = false;
                                $scope.googleDriveUploadingInProgress = false;
                            }, (er) => {
                                $scope.googleDriveUploadingInProgress = false;
                                $rootScope.alert('error', er.data);

                            });
                    } else {
                        $scope.googleDriveUploadingInProgress = false;
                        $rootScope.alert('error', error.data);
                    }
                });
        };

        let getDropboxAuthorizationUrl = () => {
            $scope.verifyingDropboxAuthorization = true;

            DropboxService.getAuthorizationUrl()
                .then((response) => {
                    $scope.dropboxAuthorizationUrl = response;
                    $scope.verifyingDropboxAuthorization = false;
                }, (error) => {
                    $scope.verifyingDropboxAuthorization = false;
                    $rootScope.alert('error', error.data);
                });
        };

        let getGoogleDriveAuthorizationUrl = () => {
            $scope.verifyingGoogleDriveAuthorization = true;

            GoogleDriveService.getAuthorizationUrl()
                .then((response) => {
                    $scope.googleDriveAuthorizationUrl = response;
                    $scope.verifyingGoogleDriveAuthorization = false;
                }, (error) => {
                    $scope.verifyingGoogleDriveAuthorization = false;
                    $rootScope.alert('error', error.data);
                });
        };

        $scope.openDropboxAuthorizationUrl = () => {
            $scope.authorizationError = false;
            $scope.dropboxAuthorizationInProgress = true;
            let x = screen.width / 2 - 450 / 2 + FindLeftWindowBoundry();
            let y = screen.height / 2 - 450 / 2 + FindTopWindowBoundry();
            $window.parentScope = $scope;
            $scope.popup = window.open($scope.dropboxAuthorizationUrl, '', 'width=450,height=450,left=' + x + ',top=' + y);

            let dropboxInterval = $interval(() => {
                if ($scope.dropboxAuthorizationDone && $scope.popup !== undefined) {
                    $scope.popup.close();
                    store.set('user', $scope.user);
                    $scope.dropboxAuthorizationInProgress = false;
                    $scope.uploadDropboxFiles();
                    $interval.cancel(dropboxInterval);
                } else if ($scope.authorizationError) {
                    $scope.popup.close();
                    $interval.cancel(dropboxInterval);
                }
            }, 1000);
        };

        $scope.openGoogleDriveAuthorizationUrl = () => {
            $scope.authorizationError = false;
            $scope.googleDriveAuthorizationInProgress = true;
            let x = screen.width / 2 - 500 / 2 + FindLeftWindowBoundry();
            let y = screen.height / 2 - 500 / 2 + FindTopWindowBoundry();
            $window.parentScope = $scope;
            $scope.popupGoogleDrive = window.open($scope.googleDriveAuthorizationUrl, '', 'width=500,height=500,left=' + x + ',top=' + y);

            let googleDriveInterval = $interval(() => {
                if ($scope.googleDriveAuthorizationDone && $scope.popupGoogleDrive !== undefined) {
                    $scope.popupGoogleDrive.close();
                    store.set('user', $scope.user);
                    $scope.googleDriveAuthorizationInProgress = false;
                    $scope.uploadGoogleDriveFiles();
                    $interval.cancel(googleDriveInterval);
                } else if ($scope.authorizationError) {
                    $scope.popupGoogleDrive.close();
                    $interval.cancel(googleDriveInterval);
                }
            }, 1000);
        };

        let checkDropboxAuthorization = () => {
            if ($scope.user.cloud_storage_credentials === undefined
                || ($scope.user.cloud_storage_credentials !== undefined
                    && ($scope.user.cloud_storage_credentials.dropbox_token === undefined
                        || $scope.user.cloud_storage_credentials.dropbox_token === ''))) {
                getDropboxAuthorizationUrl();
            } else {
                $scope.dropboxAuthorizationDone = true;
            }
        };

        let checkGoogleDriveAuthorization = () => {
            if ($scope.user.cloud_storage_credentials === undefined
                || ($scope.user.cloud_storage_credentials !== undefined
                    && ($scope.user.cloud_storage_credentials.google_drive_access_token === undefined
                        || $scope.user.cloud_storage_credentials.google_drive_access_token === ''))) {
                getGoogleDriveAuthorizationUrl();
            } else {
                $scope.googleDriveAuthorizationDone = true;
            }
        };

        checkDropboxAuthorization();
        checkGoogleDriveAuthorization();

        function FindLeftWindowBoundry() {
            // in Internet Explorer window.screenLeft is the window's left boundry
            if (window.screenLeft) {
                return window.screenLeft;
            }

            // in Firefox window.screenX is the window's left boundry
            if (window.screenX) {
                return window.screenX;
            }

            return 0;
        }

        function FindTopWindowBoundry() {
            // in Internet Explorer window.screenLeft is the window's left boundry
            if (window.screenTop) {
                return window.screenTop;
            }

            // in Firefox window.screenY is the window's left boundry
            if (window.screenY) {
                return window.screenY;
            }

            return 0;
        }
    }
}

export const ArchidriveShareComponent: ng.IComponentOptions = {
    template: require('./archidrive-share.html'),
    controller: ArchidriveShareController,
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/archidrive/archidrive-share/archidrive-share.ts